export class ChartLayerBrush {
    color: string;
    type: string;
    constructor(brushData: any) {
        brushData = (brushData || {});
        this.color = brushData.color;
        this.type = brushData.type;
    }
}
